import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Home from './components/Home';
import Footer from './components/Footer';
import AppPage from './components/AppPage'; // We will create this next
import AnalyticsTracker from './components/AnalyticsTracker'; // Import the tracker
import './App.css'; // We might create this later for App specific styles

function App() {
  return (
    <div className="wrapper"> {/* Matching the class from Hugo site */}
      <AnalyticsTracker /> {/* Add the tracker here */}
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/app" element={<AppPage />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App; 